"use strict";
/*
 * Created on 01 30 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ModifiedCompetitorPriceDTOConverter_1 = require("./ModifiedCompetitorPriceDTOConverter");

var ModifiedCompetitorPriceDTO_1 = require("../model/ModifiedCompetitorPriceDTO");
/**
 * @author Jaroslav Sevcik
 */


var ModifiedCompetitorPriceDTOConverterImpl =
/*#__PURE__*/
function (_ModifiedCompetitorPr) {
  _inherits(ModifiedCompetitorPriceDTOConverterImpl, _ModifiedCompetitorPr);

  function ModifiedCompetitorPriceDTOConverterImpl() {
    _classCallCheck(this, ModifiedCompetitorPriceDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ModifiedCompetitorPriceDTOConverterImpl).apply(this, arguments));
  }

  _createClass(ModifiedCompetitorPriceDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new ModifiedCompetitorPriceDTO_1.ModifiedCompetitorPriceDTO(conversions.toClassReferenceId(source.competitorPriceId), conversions.toBigNumber(source.modifiedPrice));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      return {
        modifiedPrice: conversions.fromBigNumber(source.modifiedPrice),
        competitorPriceId: conversions.toDocumentReferenceId(source.competitorPriceId)
      };
    }
  }]);

  return ModifiedCompetitorPriceDTOConverterImpl;
}(ModifiedCompetitorPriceDTOConverter_1.ModifiedCompetitorPriceDTOConverter);

exports.ModifiedCompetitorPriceDTOConverterImpl = ModifiedCompetitorPriceDTOConverterImpl;